import styled from 'styled-components';

export const StyledLoading = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
`;
